module.exports = __webpack_public_path__ + "static/img/oderSuccess_packet.696be684.png";